import type { CanonicalProjectEvent } from '@web/lib/projector';

export type RunEventDeliveryMode =
  | 'live'
  | 'reconnect_catch_up'
  | 'historical_rehydrate'
  | 'cloud_restore';

export type RunDomainEvent = CanonicalProjectEvent & {
  schemaVersion: 1;
  deliveryMode: RunEventDeliveryMode;
  origin: 'local' | 'cloud_restore' | 'remote';
  category:
    | 'lifecycle'
    | 'approval'
    | 'interaction'
    | 'tool'
    | 'artifact'
    | 'runtime'
    | 'sync'
    | 'memory'
    | 'other';
};

export type RunDomainEventFilter = {
  projectId?: string;
  runId?: string;
  eventTypes?: readonly string[];
  categories?: readonly RunDomainEvent['category'][];
  deliveryModes?: readonly RunEventDeliveryMode[];
};

export function categoryForRunEvent(
  eventType: string
): RunDomainEvent['category'] {
  if (eventType.startsWith('artifact.')) return 'artifact';
  if (eventType.startsWith('approval.')) return 'approval';
  if (eventType.startsWith('interaction.')) return 'interaction';
  if (eventType.startsWith('tool.')) return 'tool';
  if (eventType.startsWith('runtime.')) return 'runtime';
  if (eventType.startsWith('sync.') || eventType.startsWith('run.sync.')) {
    return 'sync';
  }
  if (eventType.startsWith('memory.')) return 'memory';
  if (eventType.startsWith('run.') || eventType.startsWith('attempt.')) {
    return 'lifecycle';
  }
  return 'other';
}
